import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';
import { createElement, FC } from 'react';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Length = string | number;

interface Props {
  width?: Length;
  height?: Length;
  size?: Length;
  color?: 'primary' | 'secondary' | 'inherit';
  className?: string;
}

const Spinner: FC<Props> = ({ width = '100%', height = 80, size = 32, color, className }) => (
  <Root width={width} height={height} className={className}>
    <div>
      <CircularProgress size={size} color={color} />
    </div>
  </Root>
);

const Root = styled('div')<{ width: Length; height: Length }>(({ width, height }) => ({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  width,
  height,
  lineHeight: 0,
}));

export default Spinner;
